import * as C from "../../../ui/common/CommonStyles";
import { Space, Tabs } from "@mantine/core";
import NoticeList from "./Notice/List";
import PopupList from "./Popup/List";

export default function AnnounceMent() {
  return (
    <div>
      <C.TitleBox>
        <div className="title">공지사항 목록</div>
      </C.TitleBox>
      <C.ListBox>
        <Tabs defaultValue="notices" keepMounted={false}>
          <Tabs.List>
            <Tabs.Tab value="notices">공지사항</Tabs.Tab>
            <Tabs.Tab value="popup">팝업</Tabs.Tab>
          </Tabs.List>
          <Space h="md" />
          <Tabs.Panel value="notices">
            <NoticeList />
          </Tabs.Panel>
          <Tabs.Panel value="popup">
            <PopupList />
          </Tabs.Panel>
        </Tabs>
      </C.ListBox>
    </div>
  );
}
